import { createSelector } from '@ngrx/store';
import lzstring from 'lz-string';
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
/**
 * Decode a string from the url and parse it as JSON. Check that the parsed object has expected attributes.
 *
 * This does not do the most comprehensive checks for valid chart annotation strings, but up to some point the user is
 * responsible for correctly editing the url.
 *
 * @param chartAnnotationStr {string}
 * @return {FundChartAnnotationOptions | undefined}
 */
function parseChartAnnotation(chartAnnotationStr) {
    try {
        return JSON.parse(lzstring.decompressFromEncodedURIComponent(chartAnnotationStr) || '{}');
    }
    catch (error) {
        // The string could not be parsed as a valid chart annotation
        return undefined;
    }
}
export const getChartAnnotations = createSelector(getChartState, (chartState) => {
    const chartAnnotationStrs = chartState?.chartAnnotations && Array.isArray(chartState.chartAnnotations) ? chartState.chartAnnotations : [];
    const chartAnnotations = [];
    chartAnnotationStrs.forEach((chartAnnotationStr) => {
        const chartAnnotation = parseChartAnnotation(chartAnnotationStr);
        if (chartAnnotation)
            chartAnnotations.push(chartAnnotation);
    });
    return chartAnnotations;
});
export const chartHasAnnotations = createSelector(getChartAnnotations, (chartAnnotations) => {
    return chartAnnotations.length > 0;
});
